// import React from 'react';
import { useInitialApp } from 'lib/useInitialApp';
import { useInitProvider } from 'providers/InitProvider';
import LauncherView from './Launcher.view';
// import { useLauncherStrategyProvider } from 'lib/launchStrategies/LauncherStrategyProvider';
import { IApp } from 'types';
import { Progress } from 'components/Progress';

const findIn = (list: IApp[]) => (code: string) =>
  list.find((app) => app.code === code);

/**
 * provider
 */
const LauncherContainer = ({
  type,
  logoHandler,
  gotoHomeHandler,
  workspaceSelected,
}) => {
  const initData = useInitProvider();
  // const { launchApplication } = useLauncherStrategyProvider();
  useInitialApp();
  // if (!initData.hasRole()) return null;
  /**
   * FIXME CREARE COMPONENTE LOADING
   */
  if (!initData.dump) return <Progress />;

  const defaultApp = findIn(initData.dump.apps)(
    initData.dump.shell.defaultApplicationId,
  );

  // const gotoHomeHandler = () => {
  //   const defaultApp = findIn(initData.dump.apps)(
  //     initData.dump.shell.defaultApplicationId,
  //   );
  //   launchApplication(defaultApp);
  //   // initData.setIsDefaultApp(true);
  // };

  const {
    apps,
    shell: { defaultApplicationId },
  } = initData.dump;

  const updatedApps = apps.filter(
    (app) =>
      app.code !== defaultApplicationId &&
      app.code !== 'account' &&
      app.code !== 'workspace',
  );

  return (
    <>
      {updatedApps ? (
        <LauncherView
          data={{ apps: updatedApps }}
          type={type}
          defaultApp={defaultApp}
          gotoHomeHandler={gotoHomeHandler}
          logoHandler={logoHandler}
          workspaceSelected={workspaceSelected}
        />
      ) : null}
    </>
  );
};

export default LauncherContainer;
